<template>
    <div class="container">
    </div>
</template>

<script>
    import {  miniLogin } from '../../../api/memberLogin'
    import { Indicator, Toast } from 'mint-ui'
    import { mapMutations, mapActions, mapState } from 'vuex'
    export default {
        name: 'Login',
        data () {
            return {
                openid: '',
            }
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                // 通过 `vm` 访问组件实例
                vm.utils.setCookie('referrer', encodeURIComponent(from.fullPath), 1 / 24)
            })
        },
        computed: {

        },
        created: function () {
            Indicator.open()
        },
        mounted () {
            miniLogin(this.$route.query.openid).then(response => {
                Indicator.close()
                this.saveAuthInfo({ token: response.result.token, info: response.result.info })
                this.goHome()
            }).catch(function (error) {
                Indicator.close()
                Toast(error.message)
            })
        },
        methods: {
            ...mapMutations({
                saveAuthInfo: 'memberLogin',
                memberLogout: 'memberLogout'
            }),
            goHome () {
                let referrer = this.utils.getCookie('referrer')
                if (referrer) { // 返回之前的页面
                    referrer = decodeURIComponent(referrer)
                    this.utils.clearCookie('referrer')
                    this.$router.push({ path: referrer })
                } else {
                    this.$router.push({ name: 'MemberIndex' })
                }
            },
        }
    }
</script>

<style scoped lang='scss'>
    .container {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #F0F2F5;
        .top-wrapper {
            .input-wrapper {
                display: flex;
                align-content: center;
                align-items: center;
                padding-left: 0.5rem;
                background-color: #fff;
                height: 2.2rem;
                img {
                    width: 1.2rem;
                    height: 1.2rem;
                    margin: 0;
                    padding: 0;
                }
                input {
                    flex: 1;
                    font-size:.8rem;
                }
                .bottom-input {
                    border-bottom-width: 0;
                }
            }
        }
    }
    .retrieve-wrapper {
        height: 2rem;
        margin-top: 0.5rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }
    .retrieve-item {
        width: 4rem;
        height: 2rem;
        margin-right: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #retrieve-title {
        color: $primaryColor;
        font-size: 0.75rem;
        text-align: center;
    }
    .bottom-wrapper {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: flex-end;
        align-items: stretch;
    }
    .auth-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        height: 13rem;
    }
    .auth-title-wrapper {
        height: 1rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 2rem;
    }
    .auth-title {
        color: #8f8e94;
        font-size: 0.7rem;
    }
    .auth-line {
        display: flex;
        flex: 1;
        height: 1px;
        background-color: #d8d8d8;
        margin-left: 0.8rem;
        margin-right: 0.8rem;
    }
    .auth-item {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }
    .auth-item-icon {
        width: 3rem;
        height: 3rem;
        text-align:center;
        font-size:3rem;

    }
    .wechat{
        color: #2db304;
    }
    .sina{
        color: #f01414;
    }
    .tencent{
        color: #26a2ff;
    }
    .auth-item-title {
        margin-top: 0.6rem;
    }
    .auth-bottom-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        margin-left: 0.75rem;
        margin-right: 0.75rem;
        margin-bottom: 1rem;
    }
</style>
